import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ViewQrCodeModalComponent } from './view-qr-code-modal.component';


export interface ViewQrCodeParams {
  qrCode: string;
  fileName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ViewQrCodeModalService {
  constructor(private matDialog: MatDialog) {}

  public open({ qrCode, fileName }: ViewQrCodeParams): Promise<void> {
    return this.matDialog.open(ViewQrCodeModalComponent, {
      data: { qrCode, fileName }
    }).afterClosed()
      .toPromise();
  }
}
